var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from '@material-ui/core';
import { FlexGrowCol, FlexRow } from '@xyo-network/sdk-xyo-react-js';
import numeral from 'numeral';
const StatCardSummary = (props) => {
    const { title, value, children, format = '0.0a' } = props, boxProps = __rest(props, ["title", "value", "children", "format"]);
    return (_jsxs(FlexGrowCol, Object.assign({ alignItems: "stretch", justifyContent: "flex-start", padding: 1 }, boxProps, { children: [_jsx(FlexRow, Object.assign({ justifyContent: "flex-start", overflow: "hidden", marginX: 0.5 }, { children: _jsx(Typography, Object.assign({ variant: "h1" }, { children: value !== undefined ? (format ? numeral(value).format(format) : value) : '- -' }), void 0) }), void 0),
            _jsx(FlexRow, Object.assign({ justifyContent: "flex-start", overflow: "hidden", marginX: 1, minHeight: 24 }, { children: _jsx(Typography, Object.assign({ variant: "subtitle2" }, { children: title }), void 0) }), void 0),
            children] }), void 0));
};
export default StatCardSummary;
